import { render } from "./add_tax_component.vue?vue&type=template&id=aa8ead3e&scoped=true"
import script from "./add_tax_component.vue?vue&type=script&lang=js"
export * from "./add_tax_component.vue?vue&type=script&lang=js"

import "./add_tax_component.vue?vue&type=style&index=0&id=aa8ead3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8ead3e"]])

export default __exports__